angular.module('picmonicng').directive('browseSrefActive', [
  'BrowseService',
  function (BrowseService) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        scope.$watch(
          function () {
            return BrowseService.state;
          },
          function () {
            checkActiveStatus();
          }
        );

        scope.$watch(
          function () {
            return BrowseService.browseOpen;
          },
          function () {
            checkActiveStatus();
          }
        );

        scope.$watch(
          function () {
            return BrowseService.secondaryState;
          },
          function () {
            checkActiveStatus();
          }
        );

        function checkActiveStatus() {
          if (BrowseService.browseOpen) {
            if (BrowseService.secondaryState) {
              if (BrowseService.secondaryState == attrs.browseSref) {
                element.addClass(attrs.browseSrefActive);
              } else {
                element.removeClass(attrs.browseSrefActive);
              }
            } else {
              if (BrowseService.state == attrs.browseSref) {
                element.addClass(attrs.browseSrefActive);
              } else {
                element.removeClass(attrs.browseSrefActive);
              }
            }
          } else {
            element.removeClass(attrs.browseSrefActive);
          }
        }
      },
    };
  },
]);
